import { useState, useRef, useEffect } from 'react';

export const useViewerState = (startPoints, currentRoom, onViewUpdate) => {
  const pannellumRef = useRef(null);
  const viewChangeInterval = useRef(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false); // ✅

  const [viewerState, setViewerState] = useState({
    yaw: startPoints?.[currentRoom]?.yaw ?? 180,
    pitch: startPoints?.[currentRoom]?.pitch ?? 0,
    // hfov: 120,
  });

  const handleViewChange = () => {
    if (pannellumRef.current) {
      const viewer = pannellumRef.current.getViewer();
      if (viewer) {
        const updated = {
          yaw: viewer.getYaw(),
          pitch: viewer.getPitch(),
          hfov: viewer.getHfov(),
        };
        setViewerState(updated);
        if (onViewUpdate) onViewUpdate(updated);
      }
    }
  };

  // useEffect(() => {
  //   const viewer = pannellumRef.current?.getViewer?.();
  //   if (!viewer) return;
  //
  //   setIsImageLoaded(false); // Reset when mediaPhoto changes
  //
  //   const handleLoad = () => {
  //     setIsImageLoaded(true);
  //   };
  //
  //   // Register event listener
  //   viewer.on('load', handleLoad);
  //
  //   return () => {
  //     viewer.off('load', handleLoad); // Clean up to prevent multiple triggers
  //   };
  // }, [mediaPhoto]); // or currentRoom, depending on when new scene loads

  // Handle mouse down event (to start tracking mouse movements)
  const handleMouseDown = () => {
    if (viewChangeInterval.current) clearInterval(viewChangeInterval.current);
    viewChangeInterval.current = setInterval(handleViewChange, 100);
  };

  // Handle mouse up event (to stop tracking mouse movements)
  const handleMouseUp = () => {
    if (viewChangeInterval.current) {
      clearInterval(viewChangeInterval.current);
      handleViewChange();
    }
  };

  useEffect(() => {
    const sp = startPoints?.[currentRoom];
    // debugger;
    if (sp) {
      setViewerState({
        yaw: sp.yaw ?? 180,
        pitch: sp.pitch ?? 0,
        hfov: sp.hfov ?? 120,
      });
    }
    // If there's no start point, DO NOTHING — keep current view
  }, [startPoints, currentRoom]);

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      if (viewChangeInterval.current) clearInterval(viewChangeInterval.current);
    };
  }, []);

  return {
    viewerState,
    pannellumRef,
    handleMouseDown,
    handleMouseUp,
    setViewerState,
    isImageLoaded, // ✅ return to use in component
  };
};
